var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-home"},[_c('img',{staticStyle:{"width":"900px"},attrs:{"src":require("../assets/logo header.svg"),"alt":"Logo Gerdau"}}),_c('p',[_vm._v(_vm._s(_vm.$t('application.smartBioLogistic')))])])}
var staticRenderFns = []

export { render, staticRenderFns }